/**
 * 증권사 고유 컬러 — qnnp-react-ts PortfolioTreeMap 컬러 승계
 */
export const BROKERAGE_COLORS: Record<string, string> = {
  NH증권: "#87d068", // green
  삼성증권: "#108eff", // blue
  한국투자증권: "#80624c", // brown
  미래에셋증권: "#f27100", // orange
};

export const brokerageColor = (name?: string): string =>
  BROKERAGE_COLORS[(name || "").trim()] || "#8c8c8c";

/**
 * 계좌 태그 — 증권사 고유 컬러 (모바일 종목명 아래 + 데스크톱 계좌 컬럼 공용)
 * account: "증권사 계좌유형" 통합 문자열 또는 brokerage별 지정
 */
export const AccountTag = ({ brokerage, account }: { brokerage?: string; account?: string }) => {
  const text = account || brokerage || "";
  const bName = brokerage || text.split(" ")[0] || "";
  const color = brokerageColor(bName);
  return (
    <span
      style={{
        fontSize: 10,
        color,
        border: `1px solid ${color}66`,
        background: `${color}14`,
        borderRadius: 3,
        padding: "0 4px",
        whiteSpace: "nowrap",
        lineHeight: "16px",
        display: "inline-block",
      }}
    >
      {text}
    </span>
  );
};
